import { onView, onMount, onDestroy } from "@/modules/_";
import gsap, { SplitText } from "@lib/gsap";

export default function (element: HTMLElement, dataset: DOMStringMap) {
  const splitTextChars = element.querySelectorAll(".char");

  gsap.set(splitTextChars, {
    filter: "blur(4px)",
    opacity: 0,
    xPercent: 4,
    z: 0,
  });

  const observer = onView(element, {
    root: null,
    rootMargin: "0px",
    threshold: 0.4,
    autoStart: false,
    once: true,
    callback: ({ isIn }) => {
      if (isIn) {
        gsap.to(splitTextChars, {
          filter: "blur(0px)",
          opacity: 1,
          xPercent: 0,
          duration: 0.6,
          ease: "power2.inOut",
          stagger: 0.05,
        });
      }
    },
  });

  onMount(() => {
    observer.start();
  });

  onDestroy(() => {
    observer.destroy();
  });
}
